export const CONTACT_US = 'UserPanel/CONTACT_US';
export const FAQ = 'UserPanel/FAQ';
export const LOG_IN = 'UserPanel/LOG_IN';
export const REGISTER = 'UserPanel/REGISTER';
